export default __webpack_public_path__ + "static/media/logo.696ecbc4.png";